export enum OfferType {
    SINGLE = 'single',
    MULTI = 'multi',
}
